import ProfileFollowingTab from './ProfileFollowingTab'

export default ProfileFollowingTab
export type { ProfileFollowingTabProps } from './ProfileFollowingTab'
